module.exports = __webpack_public_path__ + "static/img/xinnengyuan5.61371e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinnengyuan5.png
// module id = FJAv
// module chunks = 16